module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "pagehead"
  }, [_c('b', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "image0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/image1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/listofplates"
    }
  }, [_vm._v("List of Plates")]), _c('a', {
    attrs: {
      "id": "plate"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/maps"
    }
  }, [_vm._v("List of Maps")]), _c('a', {
    attrs: {
      "id": "map"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/acknowledgements"
    }
  }, [_vm._v("Acknowledgements")]), _c('a', {
    attrs: {
      "id": "ack"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/background"
    }
  }, [_vm._v("Background")]), _c('a', {
    attrs: {
      "id": "back"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1"
    }
  }, [_vm._v("Campaign Chronicle")]), _c('a', {
    attrs: {
      "id": "chap1"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1#title-1"
    }
  }, [_vm._v("June 1940: The Italian Blitz")]), _c('a', {
    attrs: {
      "id": "title_1"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1#title-2"
    }
  }, [_vm._v("July 1940: The State of Maltese Morale")]), _c('a', {
    attrs: {
      "id": "title_2"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1#title-3"
    }
  }, [_vm._v("August-December 1940: Malta’s Strategic Role")]), _c('a', {
    attrs: {
      "id": "title_3"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1#title-4"
    }
  }, [_vm._v("January 1941: The German Blitz")]), _c('a', {
    attrs: {
      "id": "title_4"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1#title-5"
    }
  }, [_vm._v("February 1941: The Luftwaffe Ascendant")]), _c('a', {
    attrs: {
      "id": "title_5"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1#title-6"
    }
  }, [_vm._v("April 1941: Rationing Introduced")]), _c('a', {
    attrs: {
      "id": "title_6"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1#title-7"
    }
  }, [_vm._v("May 1941: Allied Reverses in the Mediterranean")]), _c('a', {
    attrs: {
      "id": "title_7"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1#title-8"
    }
  }, [_vm._v("June 1941: Malta Reinforced")]), _c('a', {
    attrs: {
      "id": "title_8"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1#title-9"
    }
  }, [_vm._v("July 1941: "), _c('i', [_vm._v("Operazione C3")])]), _c('a', {
    attrs: {
      "id": "title_9"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1#title-10"
    }
  }, [_vm._v("August 1941: Malta – the Key to the Mediterranean")]), _c('a', {
    attrs: {
      "id": "title_10"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1#title-11"
    }
  }, [_vm._v("September 1941: Fortunes of the Malta Convoys")]), _c('a', {
    attrs: {
      "id": "title_11"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1#title-12"
    }
  }, [_vm._v("November 1941: A Question of Morale")]), _c('a', {
    attrs: {
      "id": "title_12"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1#title-13"
    }
  }, [_vm._v("December 1941: The Kesselring Offensive")]), _c('a', {
    attrs: {
      "id": "title_13"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1#title-14"
    }
  }, [_vm._v("January 1942: The Air Battle Continues")]), _c('a', {
    attrs: {
      "id": "title_14"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1#title-15"
    }
  }, [_vm._v("February 1942: The Demand for Spitfires")]), _c('a', {
    attrs: {
      "id": "title_15"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1#title-16"
    }
  }, [_vm._v("March 1942: Running the Axis Blockade")]), _c('a', {
    attrs: {
      "id": "title_16"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1#title-17"
    }
  }, [_vm._v("April 1942: The German Onslaught")]), _c('a', {
    attrs: {
      "id": "title_17"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1#title-18"
    }
  }, [_vm._v("May 1942: Dobbie Replaced by Lord Gort")]), _c('a', {
    attrs: {
      "id": "title_18"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1#title-19"
    }
  }, [_vm._v("June 1942: Reduced Rations")]), _c('a', {
    attrs: {
      "id": "title_19"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1#title-20"
    }
  }, [_vm._v("July 1942: Allied Air Superiority Established")]), _c('a', {
    attrs: {
      "id": "title_20"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1#title-21"
    }
  }, [_vm._v("August 1942: Operation "), _c('i', [_vm._v("Pedestal")])]), _c('a', {
    attrs: {
      "id": "title_21"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1#title-22"
    }
  }, [_vm._v("October 1942: The Luftwaffe’s Last Offensive")]), _c('a', {
    attrs: {
      "id": "title_22"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1#title-23"
    }
  }, [_vm._v("November 1942: The Siege is Raised")]), _c('a', {
    attrs: {
      "id": "title_23"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/after",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aftermath")]), _c('a', {
    attrs: {
      "id": "after"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/appendix1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendices")])]), _vm._v(" "), _c('p', {
    staticClass: "contents1"
  }, [_c('span', {
    attrs: {
      "href": "#/appendix1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Siege of Malta in Seven Acts")]), _c('a', {
    attrs: {
      "id": "app1"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents1"
  }, [_c('span', {
    attrs: {
      "href": "#/appendix2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Naval Strength in the Mediterranean 1940")]), _c('a', {
    attrs: {
      "id": "app2"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents1"
  }, [_c('span', {
    attrs: {
      "href": "#/appendix3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Malta Convoys")]), _c('a', {
    attrs: {
      "id": "app3"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents1"
  }, [_c('span', {
    attrs: {
      "href": "#/appendix4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Composition of the Key Convoys, Their Naval Escorts, and the Axis Forces Operating Against Them, July 1941-August 1942")]), _c('a', {
    attrs: {
      "id": "app4"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents1"
  }, [_c('span', {
    attrs: {
      "href": "#/appendix5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Malta’s Air Defences")]), _c('a', {
    attrs: {
      "id": "app5"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents1"
  }, [_c('span', {
    attrs: {
      "href": "#/appendix6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Malta’s Land Defences")]), _c('a', {
    attrs: {
      "id": "app6"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents1"
  }, [_c('span', {
    attrs: {
      "href": "#/appendix7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Interview with Godwin Castaldi by the Author on 12 September 2006")]), _c('a', {
    attrs: {
      "id": "app7"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents1"
  }, [_c('span', {
    attrs: {
      "href": "#/appendix8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Biographies of Key Figures")]), _c('a', {
    attrs: {
      "id": "app8"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents1"
  }, [_c('span', {
    attrs: {
      "href": "#/appendix9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")]), _c('a', {
    attrs: {
      "id": "app9"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "contents1"
  }, [_c('span', {
    attrs: {
      "href": "#/appendix10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glossary")]), _c('a', {
    attrs: {
      "id": "app10"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 69
// module chunks = 0